/* eslint-disable react/require-default-props */
import * as React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@one-thd/sui-atomic-components';
import { PhoneIMask } from './PhoneIMask';

const TextSignup = ({
  textValue = '',
  onChange,
  status = '',
  statusMessage = '',
  optional = false,
  fullWidth = false
}) => (
  <TextField
    value={textValue}
    onChange={onChange}
    id="sms"
    name="sms"
    label="Text"
    status={status}
    autoComplete="off"
    placeholder="(000) 000-0000"
    statusMessage={statusMessage}
    optional={optional}
    fullWidth={fullWidth}
    InputProps={{
      components: {
        Input: PhoneIMask,
      }
    }}
  />
);

TextSignup.defaultName = 'TextSignup';

TextSignup.propTypes = {
  textValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  status: PropTypes.string,
  statusMessage: PropTypes.string,
  optional: PropTypes.bool,
  fullWidth: PropTypes.bool
};

export { TextSignup };